<template>
  <a-input
    :placeholder="placeholder == null ? placeholderText : placeholder"
    v-model="text"
    maxlength="100"
    @pressEnter="searchEvent"
    :disabled="disabled"
  >
    <a-icon slot="prefix"  @click="searchEvent" type="search" :style="{cursor:disabled?'not-allowed':''}" />
  </a-input>
</template>

<script>
  export default {
    name: 'ptSearch',
    props:{
      disabled:{
        type:Boolean,
        defalut:false,
      },
      value:{},
      placeholder:{
        type:String,
        default:null,
      },
    },
    data(){
      return {
        text:this.value,
        placeholderText:this.$t('baseVO.searchPlaceholder'),
      }
    },
    watch:{
      text(newValue){
        this.$emit('input',newValue)
      },
      value(newValue){
        this.text = newValue;
        this.$emit('input',newValue)
      },
      placeholder(newValue){
        this.placeholderText = newValue;
      }
    },
    methods:{
      searchEvent(){
        this.$emit('input',this.text)
        this.$emit("searchEvent",this.text)
      },
    },
  }
</script>

<style scoped>

</style>